import { useEffect, useState, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useNotification } from '../../contexts/NotificationContext';
import { authFetch } from '../../utils/authFetch';
import { uploadImagem } from '../../firebase/uploadImagem';

export default function NovoPaciente() {
    const navigate = useNavigate();
    const { showNotification } = useNotification();
    const fileInputRef = useRef(null);
    
    // Adicionar estado para preview da imagem
    const [preview, setPreview] = useState(null);

    const [formData, setFormData] = useState({
        name: '',
        statusId: '',
        shift: '',
        modalityId: '',
        fatherName: '',
        motherName: '',
        educationLevel: '',
        birthdate: '',
        anamnesisDate: '',
        interventionStartDate: '',
        contractEndDate: '',
        assessmentDate: '',
        nextAssessmentDate: '',
        therapistId: ''
    });

    const [terapeutas, setTerapeutas] = useState([]);

    const situacoes = [
        { id: 0, nome: "Ativo" },
        { id: 1, nome: "Em Avaliação" },
        { id: 2, nome: "Cadastrado" },
        { id: 3, nome: "Ex Paciente" },
        { id: 4, nome: "Pausado" },
    ];

    const turnos = [
        { id: 0, nome: "Manhã" },
        { id: 1, nome: "Tarde" }
    ];

    const [modalidades, setModalidades] = useState([]);;

    useEffect(() => {
        const buscarModalidades = async () => {
            try {
                const res = await authFetch(`modality`, {
                });

                if (!res.ok) throw new Error();
                const data = await res.json();

                setModalidades(data);

            } catch (err) {
                showNotification('danger', 'Erro ao carregar modalidades');
            }
        }
        buscarModalidades();
    }, [showNotification]);

    useEffect(() => {
        const fetchTerapeutas = async () => {
            try {
                const response = await authFetch(`therapist`, {
                });
                const data = await response.json();
                setTerapeutas(data);
            } catch (err) {
                console.error(err);
                showNotification("danger", "Erro ao buscar terapeutas");
            }
        };
        fetchTerapeutas();
    }, [showNotification]);

    const handleChange = (e) => {
        const { name, value, type, files } = e.target;
        if (type === 'file' && files && files.length > 0) {
            setFormData(prev => ({ ...prev, [name]: files[0] }));
            
            // Criar preview da imagem
            const reader = new FileReader();
            reader.onload = (event) => {
                setPreview(event.target.result);
            };
            reader.readAsDataURL(files[0]);
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const imageFile = formData.image;
        let imageUrl = null;

        try {
            // Preparar payload garantindo que therapistId = 0 vire null
            const payload = {
                ...formData,
                therapistId: formData.therapistId && Number(formData.therapistId) !== 0 ? Number(formData.therapistId) : null
            };

            const response = await authFetch('patient', {
                method: 'POST',
                body: JSON.stringify(payload),
            });

            if (!response.ok) throw new Error();

            const savedData = await response.json();
            const newId = savedData.id;

            // Upload da imagem no Firebase, se houver
            if (imageFile && newId) {
                imageUrl = await uploadImagem(imageFile, 'patient', newId);
            }

            showNotification('success', 'Paciente criado com sucesso');
            navigate(`/Pacientes`);
        } catch {
            showNotification('danger', 'Erro ao criar paciente');
        }
    };


    return (
        <div className="content">
            <div className="card">
                <div className="card-body p-3">
                    <form onSubmit={handleSubmit}>
                        <div className="row col-md-12">
                            <div className="col-md-2">
                                <div className="personal-image">
                                    <input
                                        type="file"
                                        name="image"
                                        id="arquivo"
                                        accept="image/*"
                                        onChange={handleChange}
                                        ref={fileInputRef}
                                        style={{ display: 'none' }}
                                    />
                                    <figure className="personal-figure">
                                        <img
                                            src={preview || require('../../assets/img/perfilvazio.png')}
                                            className="personal-avatar"
                                            alt="imagem-perfil"
                                            onClick={() => fileInputRef.current.click()}
                                            style={{ cursor: 'pointer', width: '100%' }}
                                        />
                                        {!preview && (
                                            <figcaption className="personal-figcaption" onClick={() => fileInputRef.current.click()}>
                                                <div style={{ 
                                                    textAlign: 'center', 
                                                    color: 'white', 
                                                    fontSize: '12px',
                                                    lineHeight: '1.2',
                                                    padding: '10px'
                                                }}>
                                                    <i className="fa fa-camera" style={{ fontSize: '24px', marginBottom: '5px', display: 'block' }}></i>
                                                    Clique aqui para<br/>adicionar foto
                                                </div>
                                            </figcaption>
                                        )}
                                    </figure>
                                </div>
                            </div>
                            <div className="col-md-10">
                                <h2>Novo Paciente</h2>
                                <Link to="/Pacientes" className="btn btn-info btn-sm">Cancelar</Link>
                            </div>
                        </div>

                        <nav>
                            <div className="nav nav-tabs" role="tablist">
                                <button className="nav-link active" data-bs-toggle="tab" data-bs-target="#nav-dados" type="button">Dados</button>
                            </div>
                        </nav>

                        <div className="tab-content mt-3">
                            <div className="tab-pane fade show active" id="nav-dados">
                                <div className="row">
                                    <div className="col-md-4">
                                        <label>Nome Paciente</label>
                                        <input type='text' className='form-control form-control-sm' name="name" value={formData.name} onChange={handleChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <label>Situação</label>
                                        <select name="statusId" className='form-control form-control-sm' value={formData.statusId} onChange={handleChange}>
                                            <option value="">Selecione</option>
                                            {situacoes.map(s => (
                                                <option key={s.id} value={s.id}>{s.nome}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-4">
                                        <label>Turno</label>
                                        <select name="shift" className='form-control form-control-sm' value={formData.shift} onChange={handleChange}>
                                            <option value="">Selecione</option>
                                            {turnos.map(t => (
                                                <option key={t.id} value={t.id}>{t.nome}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-4">
                                        <label>Modalidade</label>
                                        <select name="modalityId" className='form-control form-control-sm' value={formData.modalityId} onChange={handleChange}>
                                            <option value="">Selecione</option>
                                            {modalidades.map(m => (
                                                <option key={m.id} value={m.id}>{m.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-4">
                                        <label>Nome do Pai</label>
                                        <input type='text' className='form-control form-control-sm' name="fatherName" value={formData.fatherName} onChange={handleChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <label>Nome da Mãe</label>
                                        <input type='text' className='form-control form-control-sm' name="motherName" value={formData.motherName} onChange={handleChange} />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-12">
                                        <label>Escolaridade</label>
                                        <textarea className="form-control form-control-sm" name="educationLevel" value={formData.educationLevel} onChange={handleChange} />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-3">
                                        <label>Data de Nascimento</label>
                                        <input type="date" name="birthdate" className='form-control form-control-sm' value={formData.birthdate} onChange={handleChange} />
                                    </div>
                                    <div className="col-md-3">
                                        <label>Data da Anamnese</label>
                                        <input type="date" name="anamnesisDate" className='form-control form-control-sm' value={formData.anamnesisDate} onChange={handleChange} />
                                    </div>
                                    <div className="col-md-3">
                                        <label>Início da Intervenção</label>
                                        <input type="date" name="interventionStartDate" className='form-control form-control-sm' value={formData.interventionStartDate} onChange={handleChange} />
                                    </div>
                                    <div className="col-md-3">
                                        <label>Fim do Contrato</label>
                                        <input type="date" name="contractEndDate" className='form-control form-control-sm' value={formData.contractEndDate} onChange={handleChange} />
                                    </div>
                                    <div className="col-md-3">
                                        <label>Última Avaliação</label>
                                        <input type="date" name="assessmentDate" className='form-control form-control-sm' value={formData.assessmentDate} onChange={handleChange} />
                                    </div>
                                    <div className="col-md-3">
                                        <label>Próxima Avaliação</label>
                                        <input type="date" name="nextAssessmentDate" className='form-control form-control-sm' value={formData.nextAssessmentDate} onChange={handleChange} />
                                    </div>
                                    <div className="col-md-3">
                                        <label>Gestora de Caso</label>
                                        <select name="therapistId" className='form-control form-control-sm' value={formData.therapistId} onChange={handleChange}>
                                            <option value="">Selecione</option>
                                            {terapeutas.map(t => (
                                                <option key={t.id} value={t.id}>{t.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                <div className="card-footer" style={{ paddingLeft: 0 }}>
                                    <button type="submit" className="btn btn-primary btn-sm">Salvar</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
